import React from "react";
import { Link } from "react-router-dom";
import "./ServicesItem.css";

const ServicesItem = ({ service }) => {
  const { id, title, image } = service;

  return (
    <>
    <Link to={`/services/${id}`}>
    <div className=" bg-gray-100 rounded-xl transform transition-all w-[250px] max-w-[350px] hover:-translate-y-3 duration-300 shadow-lg hover:shadow-2xl flex flex-col">
    <div className="flex w-full border-b-4 border-blue-500 imgcontainer"> <img className="h-full w-full object-cover rounded-t-xl coverimg" src={image} alt=""/>
    </div>
    <div className="p-2 text-center">
        <h2 className="font-bold text-xl m-2 ">{title}</h2>
{/*         <p className="text-sm text-gray-600">{description.slice(0, 110)} ...</p> */}
    </div>
</div>
    </Link>
    </>
  );
};

export default ServicesItem;

{/* <p>{description.slice(0, 110)}...</p> */}
{/* <Link to={`/services/${id}`}>{title}</Link> */}

{/* <div class="m-2">
        <Link to={`/services/${service.id}`} role='button' href='#' class="text-white bg-primary px-3 py-1 rounded-md hover:bg-blue-400 transition-colors duration-300 ease-in-out">Learn More</Link>
    </div> */}